import React from 'react'
import { RefundTitle, RefundTitleText, RefundIcon } from './../style'
import { Icon } from 'components/Icon'

const PopupTitle = ({ children, icon, ...props }) => {
	return (
		<RefundTitle {...props} icon={icon}>
			<RefundTitleText>
				{children}
				<RefundIcon>
					<Icon component={icon} />
				</RefundIcon>
			</RefundTitleText>
		</RefundTitle>
	)
}

export default PopupTitle
